var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 1122",
    style: {
      "enableBackground": "new 0 0 1122 1122"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st336",
    points: "320.46,422.12 320.46,699.88 561,838.75 801.54,699.88 801.54,422.12 561,283.25 \t\t"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st336",
    x1: 561,
    y1: 283.25,
    x2: 561,
    y2: 838.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st336",
    x1: 320.46,
    y1: 422.12,
    x2: 801.54,
    y2: 699.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "st336",
    x1: 801.54,
    y1: 422.12,
    x2: 320.46,
    y2: 699.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st336",
    points: "561,559.43 722.08,559.43 801.54,422.12 722.08,559.43 801.54,699.88 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st336",
    points: "560.73,560.53 480.19,421.03 320.46,422.12 480.19,421.03 561,283.25 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st336",
    points: "561,561.11 641.54,421.62 561,283.25 641.54,421.62 801.54,422.12 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st336",
    points: "320.46,699.88 399.92,559.43 561,559.43 399.92,559.43 320.46,422.12 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st336",
    points: "320.48,699.87 481.02,699.56 561,838.4 481,699.56 561.54,560.07 \t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st336",
    points: "561,561 641.54,700.5 561.03,838.39 641.54,700.5 801.54,699.88 \t\t"
  })))));
};

export default __webpack_public_path__ + "static/media/team.66bb0a73.svg";
export { SvgComponent as ReactComponent };